__turbopack_context__.v({
  "logo": "logo-module-scss-module__9j49Ya__logo",
  "logoCompanyName": "logo-module-scss-module__9j49Ya__logoCompanyName",
  "logoWings": "logo-module-scss-module__9j49Ya__logoWings",
});
